export default  {	
	data () {
		return { 
		}
	},
	created () { 
		this.updateCrud({state:'namePath', data: 'orden_pendientes'}) 
	},
}
